export default "__VITE_ASSET__B9WN03Cy__"